import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pool-composer.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a92be1ae")

_pushScopeId("data-v-a92be1ae")
const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "mb-8" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "-ml-4"
  }),
  /*#__PURE__*/_createVNode("ul", { class: "list-disc list-inside ml-2" }, [
    /*#__PURE__*/_createVNode("li", null, "An investment pool can be created with 2-8 tokens."),
    /*#__PURE__*/_createVNode("li", null, "The weights should add up to 100%."),
    /*#__PURE__*/_createVNode("li", null, " Initial balances should be in line with your weights or the pool will get drained. ")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "font-medium mb-1" }, "Tokens", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "grid grid-cols-3 mt-4 items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_7 = { class: "flex-1 flex justify-center" }
const _hoisted_8 = { class: "flex justify-end pt-1 pb-2" }
const _hoisted_9 = {
  key: 1,
  class: "w-full h-full absolute top-0 left-0"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "bg-gray-850 w-full h-full absolute top-0 left-0 rounded-lg opacity-25" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-white absolute left-4 bottom-4 text-yellow-500" }, " Editing is disabled during pool creation ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PoolCreateDefinitionFields = _resolveComponent("PoolCreateDefinitionFields")
  const _component_PoolCreateTokenRow = _resolveComponent("PoolCreateTokenRow")
  const _component_BalAlert = _resolveComponent("BalAlert")
  const _component_BalIcon = _resolveComponent("BalIcon")
  const _component_BalBtn = _resolveComponent("BalBtn")
  const _component_PoolCreateSuccessOverlay = _resolveComponent("PoolCreateSuccessOverlay")
  const _component_BalCard = _resolveComponent("BalCard")
  const _component_PoolCreateActions = _resolveComponent("PoolCreateActions")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BalCard, { class: "pt-2 relative" }, {
      default: _withId(() => [
        _createVNode(_component_PoolCreateDefinitionFields, {
          "pool-name": _ctx.poolName,
          "pool-symbol": _ctx.poolSymbol,
          "pool-owner": _ctx.poolOwner,
          "swap-fee-percentage": _ctx.swapFeePercentage,
          onPoolNameChange: _ctx.handlePoolNameChange,
          onPoolSymbolChange: _ctx.handlePoolSymbolChange,
          onPoolOwnerChange: _ctx.handlePoolOwnerChange,
          onPoolSwapFeePercentageChange: _ctx.handleSwapFeePercentageChange,
          onIsInputValid: _ctx.handleIsInputValid
        }, null, 8, ["pool-name", "pool-symbol", "pool-owner", "swap-fee-percentage", "onPoolNameChange", "onPoolSymbolChange", "onPoolOwnerChange", "onPoolSwapFeePercentageChange", "onIsInputValid"]),
        _hoisted_3,
        (_ctx.tokenListsLoaded)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.poolTokens, (token, idx) => {
                return (_openBlock(), _createBlock("div", {
                  class: "mb-3",
                  key: idx
                }, [
                  _createVNode(_component_PoolCreateTokenRow, {
                    "token-address-input": token.address,
                    "token-amount-input": token.amount,
                    "token-weight-input": token.weight,
                    "can-delete": _ctx.poolTokens.length > 2,
                    onTokenDelete: () => _ctx.deleteToken(idx),
                    onTokenAddressChange: value => _ctx.tokenAddressChange(value, idx),
                    onTokenAmountChange: value => _ctx.tokenAmountChange(value, idx),
                    onTokenWeightChange: value => _ctx.tokenWeightChange(value, idx),
                    onTokenApproved: _cache[1] || (_cache[1] = address => _ctx.handleTokenApproved(address))
                  }, null, 8, ["token-address-input", "token-amount-input", "token-weight-input", "can-delete", "onTokenDelete", "onTokenAddressChange", "onTokenAmountChange", "onTokenWeightChange"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("div", null, [
              (_ctx.tokensError)
                ? (_openBlock(), _createBlock(_component_BalAlert, {
                    key: 0,
                    type: "error",
                    class: "pl-4 pr-6 py-1",
                    size: "sm",
                    title: _ctx.tokensError.header,
                    description: _ctx.tokensError.body,
                    block: ""
                  }, null, 8, ["title", "description"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_BalBtn, {
              color: "green",
              disabled: _ctx.poolTokens.length === 8,
              onClick: _ctx.addToken
            }, {
              default: _withId(() => [
                _createVNode(_component_BalIcon, { name: "plus" })
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]),
        (_ctx.editingDisabled && !_ctx.poolCreateComplete)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11
            ]))
          : _createCommentVNode("", true),
        (_ctx.poolCreateComplete)
          ? (_openBlock(), _createBlock(_component_PoolCreateSuccessOverlay, {
              key: 2,
              "pool-id": _ctx.poolId
            }, null, 8, ["pool-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_PoolCreateActions, {
      "pool-name": _ctx.poolName,
      "pool-symbol": _ctx.poolSymbol,
      "pool-owner": _ctx.poolOwner,
      "swap-fee-percentage": _ctx.swapFeePercentage,
      "can-create-pool": _ctx.canCreatePool,
      "pool-tokens": _ctx.poolTokens,
      onCreatePoolTriggered: _ctx.handlePoolCreateTriggered,
      onCreatePoolError: _ctx.handlePoolCreateError,
      onCreatedPool: _ctx.handlePoolCreated,
      onVerifiedPool: _ctx.handlePoolVerified
    }, null, 8, ["pool-name", "pool-symbol", "pool-owner", "swap-fee-percentage", "can-create-pool", "pool-tokens", "onCreatePoolTriggered", "onCreatePoolError", "onCreatedPool", "onVerifiedPool"])
  ]))
})